import type { ReactNode } from 'react';
import styled from 'styled-components';

const IslandRoot = styled.section`
  position: relative;
  margin-top: ${({ theme }) => theme.space[4]}px;
  padding: ${({ theme }) => theme.space[6]}px;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.space[3]}px;

  ${({ theme }) => theme.device.tablet} {
    margin-top: ${({ theme }) => theme.space[1]}px;
    padding: ${({ theme }) => theme.space[2]}px;
    border-radius: 16px;
  }
`;

const IslandTitle = styled.h2`
  margin: 0 0 ${({ theme }) => theme.space[2]}px;
  font-size: ${({ theme }) => theme.fontSizes[7]}px;
  line-height: 1.5;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export interface PageIslandProps {
  /** Заголовок секции (как title в InfoBlock web-client). */
  title?: ReactNode;
  children: ReactNode;
  /** Атрибут id корневого section (например mainInfo на карточке изделия в web-client). */
  id?: string;
}

/**
 * Белый «остров» на серой канве {@link ExternalPageCanvas} — по смыслу UI/Blocks/InfoBlock в web-client.
 */
export function PageIsland({ title, children, id }: PageIslandProps) {
  return (
    <IslandRoot id={id}>
      {title != null && title !== '' ? <IslandTitle>{title}</IslandTitle> : null}
      {children}
    </IslandRoot>
  );
}
